import { useState } from 'react'

import Validation from 'src/components/Validation'

const useValidation = ({ i18n, currency, ...config }) => {
  const [ errors, setErrors ] = useState({})

  const validate = dataset => {
    const validation = Validation(i18n, currency)
    const { valid, errors } = validation.validate(dataset, config)
    setErrors(errors)
    return valid
  }

  const addError = (field, error) =>
    setErrors(errors =>
      ({ ...errors, [field]: (errors?.[field] || []).concat(error) })
    )

  const resetErrorsFor = field =>
    setErrors(errors =>
      errors?.[field]?.length ? { ...errors, [field]: null } : errors
    )

  return { errors, setErrors, validate, addError, resetErrorsFor }
}

export default useValidation
